import * as React from "react"
const EmailCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={"1em"}
    height={"1em"}
    viewBox={"0 0 19 19"}
    fill="none"
    {...props}
  >
    <g clipPath="url(#email_a)">
      <path
        fill="#174A73"
        fillRule="evenodd"
        d="M9.5 19C4.262 19 0 14.738 0 9.5S4.262 0 9.5 0 19 4.262 19 9.5 14.738 19 9.5 19Zm4.927-6.163a.213.213 0 0 0 .212-.212V6.66l-4.833 3.838a.49.49 0 0 1-.612 0L4.361 6.661v5.964c0 .117.095.212.212.212h9.854Zm-.741-6.674L9.5 9.487 5.314 6.163h8.372Zm1.936.212v6.25c0 .659-.536 1.195-1.195 1.195H4.573c-.659 0-1.195-.536-1.195-1.195v-6.25c0-.659.536-1.195 1.195-1.195h9.854c.659 0 1.195.536 1.195 1.195Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="email_a">
        <path fill="#fff" d="M0 0h19v19H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default EmailCircleIcon
